var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.TextClasses},[(_vm.component)?_c(_vm.component,_vm._b({tag:"component",attrs:{"type":_vm.type.type,"name":_vm.name.input,"value":_vm.value.value,"label":_vm.label.input}},'component',_vm.componentProps,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }